const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://lutrolls.com';

export interface SEOData {
  title: string;
  description: string;
  path: string;
}

export const seoConfig = {
  home: {
    title: 'Actually free photo editor app for iPhone - LUT Rolls',
    description: 'iPhone photo editor with cinematic LUT filters. Browse handpicked looks inspired by film, fashion, and fine art. Swipe to preview, tap to apply, fine tune in seconds.',
    path: '/'
  },
  about: {
    title: 'About Us - LUT Rolls',
    description: 'Learn about LUT Rolls and discover how our professional-grade photo filters bring cinematic color grading to your mobile photography workflow.',
    path: '/about'
  },
  gallery: {
    title: 'LUT Gallery - We offer the best photo filters',
    description: 'Explore our collection of professional LUT filters and see the transformative power of color grading. Preview cinematic filters inspired by cities worldwide.',
    path: '/gallery'
  },
  contact: {
    title: 'Contact Us - LUT Rolls',
    description: 'Get in touch with LUT Rolls for support, feedback, or collaboration opportunities. We\'re here to help you with our pro photo filter app.',
    path: '/contact'
  },
  privacy: {
    title: 'Privacy Policy - LUT Rolls',
    description: 'Read LUT Rolls privacy policy and learn how we protect your data and respect your privacy while using our professional photo filter app.',
    path: '/privacy'
  },
  features: {
    title: 'Features - LUT Rolls',
    description: 'Explore the features of LUT Rolls - photo filters, cinematic grain, textures, exposure, shadows, and other controls available to you.',
    path: '/features'
  }
} as const;

export const createPostSEO = (post: { title: string; description?: string; route?: string }, fallbackSlug?: string): SEOData => ({
  title: `${post.title} - LUT Rolls Blog`,
  description: post.description || 'Professional photo filters and color grading tips from LUT Rolls.',
  path: post.route || `/post/${fallbackSlug}`
});

export const createNotFoundSEO = (slug: string): SEOData => ({
  title: 'Post Not Found - LUT Rolls',
  description: 'Professional photo filters and color grading tips from LUT Rolls.',
  path: `/post/${slug}`
});

export const getCanonicalUrl = (path: string): string => `${SITE_URL}${path}`;
export const getSiteUrl = (): string => SITE_URL;